import axios from 'axios';

//创建一个axios对象
const instance = axios.create({
    baseURL: "/api",
    timeout: 300000,
    headers:""
})
export function get(url, params) {
    return instance.get(url, {
        params
    });
}

export function post(url, data) {
    return instance.post(url, data);
}

export function del(url) {
    return instance.delete(url)
}

export function put(url, data) {
    return instance.put(url, data)
}
export function $handleSizeChange(size) {
    this.pagesize = size;
    /*console.log(this.pagesize) */
}
export function $handleCurrentChange(currentPage) {
    this.currentPage = currentPage;
    /*console.log(this.currentPage) */
}